import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import { useTheme } from "@mui/material/styles";

const HeroTitleBox = ({
    title,
    subtitle,
    ownJsx,
    customWidth
}) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                position: "relative",
                minHeight: { xs: 200, sm: customWidth ? customWidth : 212, md: customWidth ? customWidth : 212 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                marginTop: {
                    xs: "55px",
                    md: "0px",
                },
                backgroundImage: `
        linear-gradient(
          135deg,
          rgba(17, 51, 75, 0.92) 0%,
          rgba(17, 51, 75, 0.72) 45%,
          rgba(17, 51, 75, 0.45) 100%
        ),
        url("/images/certificate-bg.jpg")
      `,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "0 0 40px 40px",
                boxShadow: "0 10px 40px rgba(0,0,0,0.12)",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    width: 350,
                    height: 350,
                    borderRadius: "50%",
                    border: "1px solid rgba(255,255,255,0.15)",
                    right: { xs: -180, md: -100 },
                    top: { xs: -150, md: -120 },
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    width: 220,
                    height: 220,
                    borderRadius: "50%",
                    border: "1px solid rgba(255,255,255,0.1)",
                    left: { xs: -120, md: -70 },
                    bottom: -100,
                }}
            />

            <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
                <Box
                    sx={{
                        maxWidth: 560,
                        mx: "auto",
                        textAlign: "center",
                    }}
                >
                    <Typography
                        component="h1"
                        sx={{
                            // color: "#fff",
                            color: theme.palette.texts.primary,
                            fontWeight: 800,
                            fontSize: {
                                xs: "2rem",
                                sm: "2.4rem",
                                md: "3rem",
                            },
                            lineHeight: 1.1,
                            letterSpacing: "-0.03em",
                            mb: 2,
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        sx={{
                            // color: "rgba(255,255,255,0.85)",
                            color: theme.palette.texts.primary,
                            fontSize: {
                                xs: "1rem",
                                md: "1.25rem",
                            },
                            lineHeight: 1.6,
                            maxWidth: 600,
                            mx: "auto",
                        }}
                    >
                        {subtitle}
                    </Typography>
                    {ownJsx}
                </Box>
            </Container>
        </Box>
    )
}

export default HeroTitleBox